import cn from 'classnames';
import { ReactNode } from 'react';
import { Importance, SignalTag } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { getImportanceDisplay } from '../activity-feed-utils';
import { getSignalDesign } from '../Detail/activity-feed-detail-utils';

interface ImportanceBarsProps {
  importance: Importance;
  signalTag: SignalTag;
}

// 3-bar priority indicator. Importance sets how many bars are active, the signal tag sets their color
export const ImportanceBars = ({ importance, signalTag }: ImportanceBarsProps): ReactNode => {
  const { activeBarCount, label } = getImportanceDisplay(importance);
  return (
    <svg
      className={cn('activity-feed-bars', `design-${getSignalDesign(signalTag)}`)}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      role='img'
      aria-label={`${label} importance`}
    >
      <rect
        className={cn('activity-feed-bar', { 'is-active': activeBarCount >= 1 })}
        x='2.5'
        y='10.834'
        width='4.16667'
        height='6.66667'
        rx='1.25'
      />
      <rect
        className={cn('activity-feed-bar', { 'is-active': activeBarCount >= 2 })}
        x='8.33398'
        y='6.66602'
        width='4.16667'
        height='10.8333'
        rx='1.25'
      />
      <rect
        className={cn('activity-feed-bar', { 'is-active': activeBarCount >= 3 })}
        x='14.166'
        y='2.5'
        width='4.16667'
        height='15'
        rx='1.25'
      />
    </svg>
  );
};
